<template>
    <f-dialog
        v-if    = "report"
        :title  = "report.name"
        v-model = "value"
        :width  = "460"
        storeLabel="Erstellen"
        @cancel = "onCancel"
        @store  = "onCreate"
    >
        <template v-slot:content>
            <div
                v-if="!loading"
                style="height: 6px;"
            ></div>
            <v-progress-linear
                v-if="loading"
                indeterminate
                color  = "primary"
                height = "6"
                class  = "w-100"
            />
            <v-form ref="form" >
                <v-card-text class="pb-0">
                    <div class="parameter-list" >
                        <div v-for="(parameter, index) in report.parameter" :key="index">
                            <div v-if = "parameter.type === 'MultiCustomer'">
                                <v-switch
                                    label="Meine Kunden"
                                    v-model = "myCustomers"
                                    class="mb-6 mt-0 pt-0"
                                    :ripple = "false"
                                    @change = "onMyCustomer"
                                    dense
                                    hide-details
                                />

                                <v-autocomplete
                                    dense
                                    chips
                                    label="Kunden"
                                    multiple
                                    deletable-chips
                                    hide-no-data
                                    return-object
                                    auto-select-first
                                    :hide-selected = "true"
                                    v-model       = "customer"
                                    :items        = "limCustomer"
                                    :menu-props   = "menuProps"
                                    item-value    = "id"
                                    item-text     = "name"
                                    autocomplete  = "off"
                                    autocorrect   = "off"
                                    autocapitalize= "off"
                                    spellcheck    = "false"
                                    append-icon=""
                                    small-chips
                                    clearable
                                    :readonly      = "!!configuration|| myCustomers"
                                >
                                    <template v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title class="component-title" v-html="data.item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </div>

                            <f-enum-autocomplete
                                v-if = "parameter.type === 'Customer'"
                                v-model = "customer"
                                label   = "Kunde"
                                module  = "msd"
                                type    = "limCustomer"
                                class   = "mb-2"
                                clearable
                                :rules  = "[customerRequiredRule]"
                                :readonly      = "!!configuration"
                            />

                            <f-enum-autocomplete
                                v-if = "parameter.type === 'AllCustomer'"
                                v-model = "customer"
                                label   = "Kunde"
                                module  = "msd"
                                type    = "customer"
                                class   = "mb-2"
                                clearable
                                :rules  = "[customerRequiredRule]"
                                :readonly      = "!!configuration"
                            />

                            <f-enum-autocomplete
                                v-if = "parameter.type === 'User'"
                                v-model = "user"
                                label   = "Bearbeiter"
                                module  = "msd"
                                type    = "users"
                                class   = "mb-2"
                                :rules  = "[userRequiredRule]"
                                item-text = "name"
                                :clearable = "true"
                                :disabled      = "!!configuration"
                            />

                            <c-site-select-single
                                v-if = "parameter.type === 'Site'"
                                :customer = "customer"
                                @site     = "onSite"
                            />

                            <div v-if="parameter.type === 'FromDate' || parameter.type === 'OptionalFromDate'">
                                <v-text-field
                                    v-model = "fromDate"
                                    type           = "date"
                                    :label         = "parameter.name"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :disabled      = "!!configuration"
                                />
                            </div>

                            <div v-if="parameter.type === 'ToDate' || parameter.type === 'OptionalToDate'">
                                <v-text-field
                                    v-model        = "toDate"
                                    :label         = "parameter.name"
                                    type           = "date"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :disabled      = "!!configuration"
                                />
                            </div>
                            <div v-if="parameter.type === 'LimEnd'">
                                <v-text-field
                                    v-model        = "limEnd"
                                    :label         = "parameter.name"
                                    type           = "date"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :disabled      = "!!configuration"
                                    clearable
                                />
                            </div>
                            <div v-if="parameter.type === 'DocType'">
                                <v-select
                                    :items         = "doctypes"
                                    label          = "Dokumententyp"
                                    v-model        = "docType"
                                    :disabled      = "!!configuration"
                                />
                            </div>
                            <div v-if="parameter.type === 'Locale'">
                                <v-select
                                    :items         = "locales"
                                    label          = "Sprache"
                                    v-model        = "locale"
                                    item-value     = "id"
                                    item-text      = "name"
                                    :return-object = true
                                    :disabled      = "!!configuration"
                                />
                            </div>

                            <div v-if="parameter.type === 'Stored' && report.configurations">
                                <v-select
                                    :items         = "report.configurations"
                                    label          = "VE"
                                    v-model        = "configuration"
                                    item-value     = "id"
                                    item-text      = "fullname"
                                    :return-object = "true"
                                    :clearable     = "true"
                                    @change        = "onConfiguration"
                                />
                            </div>

                            <div v-if="parameter.type === 'ScheduledZUS'">
                                <v-switch
                                    label="Mit geplanten ZÜS Prüfungen"
                                    v-model = "scheduled"
                                    class="mb-6 mt-0 pt-0"
                                    :ripple = "false"
                                    dense
                                    hide-details
                                    :disabled      = "!!configuration"
                                />
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-form>
        </template>

    </f-dialog>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import Report            from "@/modules/rep/service/Report";
import CSiteSelectSingle from "@/modules/msd/unit/components/controlls/CSiteSelectSingle";
import FDialog           from "@/modules/core/components/utils/FDialog";
import FEnumAutocomplete from "@/modules/core/components/utils/FEnumAutocomplete";
import report from "@/modules/rep/service/Report";

export default {
    name: "ReportDialog",

    components: {
        FEnumAutocomplete,
        FDialog,
        CSiteSelectSingle,
    },

    props: {
        value: {

        },

        report: {
        }
    },

    data: () => ({
        show    : false,
        loading : false,
        customer: null,
        user    : null,
        format  : null,
        site    : null,
        fromDate: null,
        toDate  : null,
        limEnd  : null,
        docType: null,
        locale  : null,
        configuration: null,
        myCustomers: false,
        scheduled: false,
        menuProps: {
            closeOnClick: true,
            maxHeight: 300,
            auto: false
        },
        doctypes: [
            "Prüfbericht",
            "Wartungsnachweis",
        ],
        locales: [
            { id: "de_DE", name: "Deutsch"},
            { id: "en_UK", name: "English"}
        ]
    }),


    mounted() {
        this.user = this.currentUser;
        this.locale = this.locales[0];
        this.fromDate = "2022-01-01"
        this.toDate   = Core.format.date.today();
        this.limEnd   = Core.format.date.today();
    },

    watch: {
        value () {
            this.show = this.value;
            this.customer = null;
            this.site = null;
            this.myCustomers = false;
        },
        report: {
            deep: true,
            handler: function () {
                this.format = this.report.format;
            }
        },

        docType () {
            console.log("docType", this.docType)
        }
    },

    computed: {
        formats () {
            return this.$store.getters.reportFormats;
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        currentUser () {
            return this.preferences.user;
        },

        limCustomer () {
            const enums = this.$store.getters ['msd'];
            return enums['limCustomer']
        },

        myCustomersList () {
            return this.preferences.customer;
        },
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onSite (site) {
            this.site = site;
        },

        onCreate () {
            if (!this.$refs.form.validate()) {
                return;
            }

            const parameter = [];
            if (this.isParameter("Customer") || this.isParameter("AllCustomer")) {
                parameter.push({
                    name   : "Customer",
                    display: "Kunde",
                    value  : this.customer ? {
                        id  : this.customer.id,
                        name: this.customer.name
                    } : {
                        id  : null,
                        name: "alle"
                    }
                })
            }

            if (this.isParameter("MultiCustomer")) {
                console.log("MultiCustomer", this.customer)
                let customers = null;
                if (this.customer) {
                    customers = [];

                    this.customer.forEach(c => customers.push({
                        id  : c.id,
                        name: c.name,
                    }))              ;
                }

                parameter.push({
                    name     : "MultiCustomer",
                    display  : "Kunden",
                    customers: customers
                })
            }

            if (this.isParameter("Site")) {
                parameter.push({
                    name   : "Site",
                    display: "Anlagennummer",
                    value  : this.site ? {
                        id  : this.site.id,
                        name: this.site.fabricNo
                    } : {
                        id  : null,
                        name: "alle"
                    }
                })
            }

            if (this.isParameter("User")) {
                parameter.push({
                    name   : "User",
                    display: "Bearbeiter",
                    value  : this.user ? {
                        id  : this.user.id,
                        name: this.user.name
                    } : {
                        id  : null,
                        name: "alle"
                    }
                })
            }


            if (this.isParameter("LimEnd")) {
                parameter.push({
                    name   : "LimEnd",
                    display: "Ende Liftmanagement",
                    dateValue: this.limEnd
                })
            }

            if (this.isParameter("FromDate")) {
                parameter.push({
                    name   : "FromDate",
                    display: "von",
                    dateValue: this.fromDate
                })
            }

            if (this.isParameter("ToDate")) {
                parameter.push({
                    name   : "ToDate",
                    display: "bis",
                    dateValue: this.toDate
                })
            }

            if (this.isParameter("OptionalFromDate")) {
                parameter.push({
                    name   : "OptionalFromDate",
                    display: "von",
                    dateValue: this.fromDate
                })
            }

            if (this.isParameter("OptionalToDate")) {
                parameter.push({
                    name   : "OptionalToDate",
                    display: "bis",
                    dateValue: this.toDate
                })
            }

            if (this.isParameter("DocType")) {
                parameter.push({
                    name   : "DocType",
                    display: "Dokumentetntyp",
                    strValue: this.docType
                })
            }

            if (this.isParameter("Locale")) {
                parameter.push({
                    name   : "Locale",
                    display: "Sprache",
                    strValue: this.locale ? this.locale.id : null
                })
            }

            if (this.isParameter("ScheduledZUS")) {
                parameter.push({
                    name   : "ScheduledZUS",
                    display: "mit geplanten ZÜS Prüfungen",
                    boolValue: this.scheduled ? "true" : "false"
                })
            }

            if (this.isParameter("Stored")) {
                parameter.push({
                    name   : "Stored",
                    display: this.configuration ? this.configuration.fullname : null,
                    value  : this.configuration ? {
                        id  : this.configuration.id,
                        name: this.configuration.fullname
                    } : {
                        id  : null,
                        name: null
                    }
                })
            }

            if (report.customer(this, this.report, parameter, this.configuration)) {
                return;
            }

            this.loading = true;
            console.log("parameter")
            Report.perform(this.report.id, 1, parameter, () => {
                this.loading = false;
                this.$emit("input", false);
            }, () => {
                this.loading = false;
            })
        },

        onConfiguration () {
            if (this.configuration) {
                this.customer = this.configuration.customer;
            }
        },

        onMyCustomer () {
            if (this.myCustomers) {
                this.customer = [];
                this.myCustomersList.forEach(customer => {
                    this.customer.push(customer);
                })
            }
        },

        customerRequiredRule (value) {
            const parameter = this.report.parameter.find (p => p.type === 'Customer');
            if (parameter && parameter.required) {
                return Core.rule.required(value);
            }

            return true;
        },

        userRequiredRule (value) {
            const parameter = this.report.parameter.find (p => p.type === 'User');
            if (parameter && parameter.required) {
                return Core.rule.required(value);
            }

            return true;
        },

        isParameter (type) {
            const p = this.report.parameter.find(p => p.type === type);
            return p != null
        },

        itemText (item) {
            return item.firstname + " " + item.lastname;
        }
    }
}
</script>

<style scoped>

.headline {
    font-size: 16px!important;
    height: 35px;
    padding-top: 3px!important;
    padding-left: 10px!important;
}

::v-deep .v-select.v-input--dense .v-chip {
    width: calc(100% - 10px);
    margin-top: 4px;
    margin-left: 0;
    margin-right: 0;
}

::v-deep .v-chip .v-chip__content {
    width: 100%;
    justify-content: space-between;
}

</style>